import { ComponentType, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { InterfaceTheme } from '@robocorp/robocloud-internal-cds-sdk/lib/src/types/RcInstanceDB';

import { useTheme, useUser } from '~/hooks';

export const withGlobalUserSettings = (WrappedComponent: ComponentType) => () => {
  const user = useUser();
  const userLanguage = user?.details.language;
  const userTheme = user?.details.theme;

  const { i18n } = useTranslation();
  const { setTheme } = useTheme();

  useEffect(() => {
    // TODO: Current user details don't include language preference, default to English for now
    const currentLanguage = 'en'; // currentUser?.details?.language

    if (currentLanguage !== userLanguage) {
      i18n.changeLanguage(currentLanguage);
    }

    // Default theme has been changed and is explicitly set to `system` for new users,
    // fallback to default `dark` theme for older users that have no explicit theme set
    setTheme(userTheme || InterfaceTheme.dark);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLanguage, userTheme]);

  return <WrappedComponent />;
};
